export const stickyButton = () => {
    const hero = document.querySelector(".hero");
    const footer = document.querySelector("footer");
    const btn = document.querySelector(".sk-btn--sticky");
    const whatsappLink = document.querySelector('.whatsapp-link');

    if (!hero || !footer || !btn) return;

    let isHeroVisible = true;
    let isFooterVisible = false;

    const update = () => {
        const isMobile = window.innerWidth < 530 ? true : false;

        if (!isHeroVisible && !isFooterVisible) {
            btn.classList.add("is-visible");
            if(isMobile && whatsappLink) whatsappLink.style.bottom = '100px';
        } else {
            btn.classList.remove("is-visible");
            if(isMobile && whatsappLink) whatsappLink.style.bottom = '35px';
        }
    };

    // HERO observer
    const heroObserver = new IntersectionObserver(
        ([entry]) => {
            isHeroVisible = entry.isIntersecting;
            update();
        },
        {
            threshold: 0,
        }
    );

    // FOOTER observer
    const footerObserver = new IntersectionObserver(
        ([entry]) => {
            isFooterVisible = entry.isIntersecting;
            update();
        },
        {
            threshold: 0,
        }
    );

    heroObserver.observe(hero);
    footerObserver.observe(footer);
};